export default {
  selectSurvey: {
    heading: 'Seleziona sondaggio',
    headingDefault: 'Seleziona sondaggio predefinito',
    noDefault: 'Nessun sondaggio predefinito'
  }
};